import { GET_DOCUMENT_TYPES, GET_MY_DOCUMENTS } from "../actions/types";

const initialState = {
  types: [],
  mydocuments: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_MY_DOCUMENTS:
      const { documents } = payload;
      return {
        ...state,
        mydocuments: documents,
      };
    case GET_DOCUMENT_TYPES:
      return {
        ...state,
        types: payload,
      };

    default:
      return state;
  }
}
